import { render, staticRenderFns } from "./RevisionListItem.vue?vue&type=template&id=6bbe2d3c&"
import script from "./RevisionListItem.vue?vue&type=script&lang=ts&"
export * from "./RevisionListItem.vue?vue&type=script&lang=ts&"
import style0 from "./RevisionListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports